export default __webpack_public_path__ + "static/overpass-lotus-headlines-b28357b1f4701ae8be5e4b6ab77e2940.woff2";